import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);
  const [impersonating, setImpersonating] = useState(!!localStorage.getItem("esp26_token_real"));

  useEffect(() => {
    const token = localStorage.getItem("esp26_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("esp26_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("esp26_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("esp26_token");
    localStorage.removeItem("esp26_token_real");
    setUser(false);
  };

  const impersonate = async (userId) => {
    const { data } = await api.post(`/admin/impersonate/${userId}`);
    if (!localStorage.getItem("esp26_token_real")) {
      localStorage.setItem("esp26_token_real", localStorage.getItem("esp26_token"));
    }
    localStorage.setItem("esp26_token", data.token);
    window.location.href = "/dashboard";
  };

  const stopImpersonation = () => {
    const real = localStorage.getItem("esp26_token_real");
    if (real) {
      localStorage.setItem("esp26_token", real);
      localStorage.removeItem("esp26_token_real");
    }
    window.location.href = "/dashboard";
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, setUser, impersonate, stopImpersonation, impersonating }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
